<template>
  <button
    class="tp-pill"
    :class="{ 'tp-pill--on': modelValue }"
    @click="$emit('update:modelValue', !modelValue)"
  >
    <span class="tp-icon">
      <slot name="icon" />
    </span>
    <span><slot /></span>
  </button>
</template>

<script setup lang="ts">
defineProps<{
  modelValue: boolean;
}>();

defineEmits<{
  'update:modelValue': [value: boolean];
}>();
</script>

<style scoped>
.tp-pill {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px 4px 7px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 20px;
  background: transparent;
  cursor: pointer;
  font-family: 'Lato', sans-serif;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.02em;
  color: rgba(107, 114, 128, 0.7);
  transition: all 0.2s ease;
  -webkit-tap-highlight-color: transparent;
  user-select: none;
}
.tp-pill:active {
  transform: scale(0.96);
}
.tp-pill--on {
  background: rgba(6, 200, 255, 0.08);
  border-color: rgba(6, 200, 255, 0.3);
  color: #009FE3;
}
:is(.dark *).tp-pill {
  border-color: rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.4);
}
:is(.dark *).tp-pill--on {
  background: rgba(6, 200, 255, 0.12);
  border-color: rgba(6, 200, 255, 0.25);
  color: #06C8FF;
}
.tp-icon {
  width: 13px;
  height: 13px;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.tp-icon :deep(svg) {
  width: 13px;
  height: 13px;
}
</style>
